import { render, staticRenderFns } from "./FilterByParentSelectLight.vue?vue&type=template&id=4ae19f90"
import script from "./FilterByParentSelectLight.vue?vue&type=script&lang=js"
export * from "./FilterByParentSelectLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports